import React, { useEffect, useState } from "react";
import "./styles/dashboard.css";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import CommonHeader from "./components/CommonHeader";

const CancelledBookings = () => {

  const doc = new jsPDF();

  const navigate = useNavigate();

  const [bookings, setBookings] = useState(null);

  const [times, setTimes] = useState(null);

  const [pickups, setPickups] = useState(null);

  const [followupStatus, setFollowupStatus] = useState(null);

  const [dele, setDele] = useState(false);

  let slno  = 0;

  function handlePDF() {
    if (!bookings || bookings.length === 0) {
      toast.error('No data to export');
      return;
    }

    // Prepare data for PDF with row styling
    const tableData = bookings.map((booking, index) => {
      const rowData = [
        index + 1,
        booking.pax_name,
        booking.pax_contact_no,
        booking.drop_point_name,
        booking.pickup_point_name,
        booking.sub_pickup,
        booking.agency_name,
        booking.remarks,
        booking.last_modified_user,
        booking.last_modified_on
      ];

      // Apply row styling based on follow_up_status_color_code
      const rowStyle = {};
      if (booking.follow_up_status_color_code) {
        rowStyle.fillColor = booking.follow_up_status_color_code;
        rowStyle.textColor = [0, 0, 0]; // Black text for colored backgrounds
      }

      return {
        data: rowData,
        styles: rowStyle
      };
    });

    // Create PDF table
    doc.autoTable({
      head: [['Sl No', 'Pax Name', 'Contact No', 'Drop Point', 'Pickup Point', 'Sub Pickup', 'Agency Name', 'Remarks', 'Last Modified By', 'Last Modified On']],
      body: tableData.map(row => row.data),
      theme: 'grid',
      styles: {
        fontSize: 8,
        cellPadding: 2
      },
      headStyles: {
        fillColor: [66, 139, 202],
        textColor: [255, 255, 255],
        fontStyle: 'bold'
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      },
      didParseCell: function(data) {
        // Apply custom row styling
        const rowIndex = data.row.index;
        if (rowIndex > 0 && tableData[rowIndex - 1] && tableData[rowIndex - 1].styles.fillColor) {
          data.cell.styles.fillColor = tableData[rowIndex - 1].styles.fillColor;
          data.cell.styles.textColor = tableData[rowIndex - 1].styles.textColor;
        }
      }
    });

    doc.save('Cancelled_Bookings_Report.pdf');
  }

  function handleSubmit() {

    const data = new URLSearchParams();

    data.append('pickup_date', document.getElementById('date').value);
    data.append('time_id', document.getElementById('time').value);
    data.append('pickup_point_id', document.getElementById('pickup').value);
    data.append('follow_up_status_fk', document.getElementById('followup_status').value);
    
    fetch(`${process.env.REACT_APP_API_URL}/booking/getcancelledlist`, {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: data,
    }).then(async (res) => {
      let resp = await res.json();
      console.log(resp);

      if (resp.message === "OK") {

        if (resp.list.length === 0) {
          toast.error('No data found');
        } else {
          setBookings(resp.list);
        }

      } else {
        toast.error(resp.message);
      }
    });
  }

  function formatDate(date) {
    var day = date.getDate();
    var month = date.getMonth() + 1; // Months are zero based
    var year = date.getFullYear();

    // Add leading zeros to day and month if necessary
    if(day < 10) {
        day = '0' + day;
    }
    if(month < 10) {
        month = '0' + month;
    }

    return year + '-' + month + '-' + day;
}

  useEffect(() => {

    fetch(`${process.env.REACT_APP_API_URL}/suggests/getbustimings`, {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: [],
    }).then(async (res) => {
      let resp = await res.json();
      if (resp.message === "OK") {

        setTimes(resp.list);
        console.log(resp);

      } else {

        toast.error(resp.message);

      }

      
    });


    fetch(`${process.env.REACT_APP_API_URL}/suggests/getpickuplocations`, {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: [],
    }).then(async (res) => {
      let resp = await res.json();
      if (resp.message === "OK") {

        setPickups(resp.list);
        console.log(resp);

      } else {

        toast.error(resp.message);

      }

      
    });

    fetch(`${process.env.REACT_APP_API_URL}/suggests/getfollowupstatus`, {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: [],
    }).then(async (res) => {
      let resp = await res.json();
      if (resp.message === "OK") {

        setFollowupStatus(resp.list);
        console.log(resp);

      } else {

        toast.error(resp.message);

      }

      
    });



    if (dele) {
      handleSubmit();
      setDele(false);
    }

    const timeoutId = setTimeout(() => {
      const dateElement = document.getElementById('date');
      if (dateElement) {
        dateElement.value = formatDate(new Date());
      }
    }, 700);

    // Cleanup timeout on unmount
    return () => clearTimeout(timeoutId);


   
  }, [dele])
  

  
   

  

  return (
    <>
      <div class="d-flex flex-column flex-lg-row h-lg-full bg-surface-secondary">
        <div class="h-screen flex-grow-1 overflow-y-lg-auto">
          <CommonHeader />

          <main class="py-6 bg-surface-secondary">
            <div class="container-fluid">
              <div class="card shadow border-0 mb-7">
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "left",
                    gap: "2rem",
                    flexWrap: "wrap",
                    padding: "32px 0 28px",
                    paddingLeft: "24px",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ color: "black", marginBottom: "0.3rem", fontSize: "0.875rem" }}>Pickup Date:</label>
                    <input
                      className="form-control form-control-sm"
                      type="date"
                      id="date"
                      style={{ minWidth: "140px" }}
                    />
                  </div>

                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ color: "black", marginBottom: "0.3rem", fontSize: "0.875rem" }}>Bus Time:</label>
                    <select
                      id="time"
                      class="form-select form-select-sm"
                      style={{ minWidth: "140px" }}
                    >
                      <option selected value={''}>Choose...</option>
                      {
                        times ? (
                          times.map((time)=>{

                           return <option value={time.time_id}>{time.time_name}</option>

                          })
                        ):(
                          <option>...</option>
                        )
                      }
                      
                    </select>
                  </div>

                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ color: "black", marginBottom: "0.3rem", fontSize: "0.875rem" }}>Pickup:</label>
                    <select
                      id="pickup"
                      class="form-select form-select-sm"
                      style={{ minWidth: "140px" }}
                    >
                      <option selected value={''}>All...</option>
                      {
                        pickups ? (
                          pickups.map((time)=>{

                           return <option value={time.pickup_point_id}>{time.pickup_point_name}</option>

                          })
                        ):(
                          <option>...</option>
                        )
                      }
                      
                    </select>
                  </div>

                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ color: "black", marginBottom: "0.3rem", fontSize: "0.875rem" }}>Follow-up Status:</label>
                    <select
                      id="followup_status"
                      class="form-select form-select-sm"
                      style={{ minWidth: "140px" }}
                    >
                      <option selected value={''}>All...</option>
                      {
                        followupStatus ? (
                          followupStatus.map((status)=>{

                           return <option value={status.follow_up_status_id}>{status.follow_up_status_name}</option>

                          })
                        ):(
                          <option>...</option>
                        )
                      }
                      
                    </select>
                  </div>

                  <button
                    className="btn btn-primary btn-sm shadow-none"
                    onClick={handleSubmit}
                    style={{ height: "31px", marginBottom: "1px" }}
                  >
                    Submit
                  </button>
                </div>

                {/* Quick Pickup Location Buttons */}
                {pickups && pickups.length > 0 && (
                  <div class="mt-3 mb-4">
                    <div class="d-flex align-items-center mb-2">
                      <span style={{ color: "black", fontWeight: "500" }}>Quick Access:</span>
                    </div>
                    <div class="d-flex flex-wrap gap-2">
                      <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => {
                          document.getElementById('pickup').value = '';
                          handleSubmit();
                        }}
                      >
                        All Pickups
                      </button>
                      {pickups.map((pickup) => (
                        <button
                          key={pickup.pickup_point_id}
                          className="btn btn-outline-secondary btn-sm"
                          onClick={() => {
                            document.getElementById('pickup').value = pickup.pickup_point_id;
                            handleSubmit();
                          }}
                          title={`View cancelled bookings for ${pickup.pickup_point_name}`}
                        >
                          {pickup.pickup_point_name}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                <div class="table-responsive">
                  <table class="table table-hover table-nowrap" id="myTable">
                    <thead class="thead-light">
                      <tr>
                        <th>Sl No</th>
                        <th scope="col">Pax Name</th>
                        <th scope="col">Contact No</th>
                        <th scope="col">Drop Point</th>
                        <th scope="col">Pickup Point</th>
                        <th scope="col">Sub Pickup</th>
                        <th scope="col">Agency Name</th>
                        <th>Remarks</th>
                        <th>Last Modified By</th>
                        <th>Last Modified On</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                      
                      bookings ? (
                        
                        bookings.map((booking, user) => {
                          slno++;
                          var telno = "tel:"+booking.pax_contact_no;
                          var user_details = booking.added_user + " on " + booking.added_on + ", "+ booking.time_name;
                          
                          // Add row highlighting based on follow_up_status_color_code
                          const rowStyle = booking.follow_up_status_color_code ? {
                            backgroundColor: booking.follow_up_status_color_code
                          } : {};
                          
                          return (
                            <tr style={rowStyle}>
                              <td>{slno}</td>
                              <td>{booking.pax_name}</td>
                              <td>
                                <a href={telno}>{booking.pax_contact_no}</a>
                              </td>
                              <td>{booking.drop_point_name}</td>
                              <td>
                                {booking.pickup_point_name}
                              </td>
                              <td>
                                {booking.sub_pickup}
                              </td>
                              <td>
                                {booking.agency_name}
                              </td>
                              <td title={user_details}>{booking.remarks}</td>
                              <td>{booking.last_modified_user}</td>
                              <td>{booking.last_modified_on}</td>
                            </tr>
                          );
                        })
                      ) : (
                        
                        <tr>
                          
                            <td colSpan={'10'} >Submit bus time and pickup date to see cancelled bookings.</td>
                          
                        </tr>
                        
                      )}
                    </tbody>
                  </table>
                </div>
                <div class="card-footer border-0 py-5">
                  <button
                        class="btn d-inline-flex btn-sm btn-primary mx-1"
                        onClick={handlePDF}
                      >
                        <span class=" pe-2">
                          <i class="bi bi-download"></i>
                        </span>
                        <span>PDF</span>
                      </button>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default CancelledBookings; 